import { authorizedFetch } from './httpClient';

const API_URL = process.env.REACT_APP_API_URL;

export interface OrganizationInfo {
  id: string;
  name: string;
  createdAt: string;
}

export interface ChildInfo {
  id: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  sex: string;
  createdAt: string;
  organizations: OrganizationInfo[];
  pendingLiabilitiesAmount: number;
}

export interface PaginatedResponse<T> {
  rows: T[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export const getChildren = async (): Promise<PaginatedResponse<ChildInfo>> => {
  const response = await authorizedFetch(`${API_URL}/api/children`);
  if (!response.ok) throw new Error('Failed to fetch children');
  return response.json();
};

export interface CreateChildRequest {
  firstName: string;
  lastName: string;
  birthDate: string; // YYYY-MM-DD
  sex: 'MALE' | 'FEMALE';
}

export type ViolationField = 'FIRST_NAME' | 'LAST_NAME' | 'BIRTH_DATE' | 'SEX';
export type ViolationReason = 'EMPTY' | 'TOO_SHORT' | 'TOO_LONG';

export interface CreateChildViolation {
  violation: string;
  details: { field: ViolationField; reason: ViolationReason };
}

export interface CreateChildResult {
  isSuccess: boolean;
  success: { id: string } | null;
  error: { violations: CreateChildViolation[] } | null;
}

export const createChild = async (request: CreateChildRequest): Promise<CreateChildResult> => {
  const response = await authorizedFetch(`${API_URL}/api/children`, {
    method: 'POST',
    body: JSON.stringify(request),
  });
  if (response.ok) {
    const success = await response.json() as { id: string };
    return { isSuccess: true, success, error: null };
  }
  const error = await response.json() as { violations: CreateChildViolation[] };
  return { isSuccess: false, success: null, error };
};
